// Yotpo
waitForElement('.yotpo .main-widget').then((el) => {
  el.querySelector('.write-question-review-buttons-container').setAttribute("role", "tablist")
  el.querySelectorAll('.yotpo-user-title').forEach(item => {
    item.closest('.label-with-tooltip').removeAttribute("aria-level")
    item.setAttribute("aria-level", "3")
  })
  el.querySelectorAll('.yotpo-user-name').forEach(item => {
    item.removeAttribute("aria-level")
  })
  el.querySelector('.reviews-amount').removeAttribute("aria-level")
})

// Kiwi Sizing Chart
waitForElement('.ks-table-wrapper').then((el) => {
  el.setAttribute('tabindex', '0')
})

waitForElement('.ks-image img').then((el) => {
  el.setAttribute('alt', 'kiwi sizing')
})

// Nosto
waitForElement('.nosto_element .points-logo').then((el) => {
  el.setAttribute('alt', 'points-logo')
})

waitForElement('.js-pdp-product-recommendations .nosto-slider .card-slider-button').then((el) => {
  const nosto_element = el.closest('.nosto_element')
  const id = nosto_element.getAttribute("id")

  nosto_element.querySelectorAll('.card-slider-button').forEach(item => {
    item.setAttribute('aria-controls', id)
  })
})

waitForElement('.js-pdp-product-recommendations .nosto-slider').then(el => {
  const config = { attributes: true }
  const slides = el.querySelectorAll('.card-slider__slide')

  slides.forEach(item => {
    const observer = new MutationObserver(() => {
      observer.disconnect()
      item.setAttribute('role', 'listitem')
      item.removeAttribute('aria-hidden')
      item.removeAttribute('tabindex')
      observer.observe(item, config)
    })
    observer.observe(item, config)
  })
})